import { RotatingLines } from 'react-loader-spinner'

export default function RowSpinner({ size = 60, fullPage = false }) {
  return (
    <div
      className="row justify-content-center text-primary"
      style={
        fullPage
          ? {
              height: '75vh',
              display: 'flex',
              alignItems: 'center'
            }
          : {}
      }>
      <div style={{ width: size, height: size }}>
        <SimpleSpinner size={size} />
      </div>
    </div>
  )
}

export function SimpleSpinner({ size }) {
  return <RotatingLines strokeColor="currentColor" height={size || 60} width={size || 60} />
}
